const Colors = {
  common: {
    primary: '#10cfc9',
    primary_hover: '#01b9b2',
    primary_bg: '#8dd9d656',
    primary_light: '#EFFFFE',
    disabled: '#e5e5e6',
    secondary: '#454E64',
    secondary_hover: '#20283b',
    secondary_button_hover: '#0b0f16',
    opacity_hover: 'rgba(0, 0, 0, 0.04)',
    warning: '#f8ac59',
    warning_light: '#FBCD9B',
    white: '#ffffff',
    textButton: '#353e56',
    blacks: {
      b_01: '#444b52',
      b_02: '#676a6c',
      b_03: '#787c7e',
      b_04: '#606060',
    },
    grays: {
      g_01: '#333333',
      g_02: '#bababe',
      g_03: '#e5e5e6',
      g_04: '#f5f5f5',
      g_05: '#f8f8f8',
      g_06: '#D7D7D8',
      g_07: '#F4F4F7',
      g_08: '#868E96',
      g_09: '#eff0f5',
      g_10: '#e4e7eb',
      g_11: '#d1dade',
      g_12: '#e7eaec',
      g_13: '#888',
      g_14: '#C9CACC',
      g_15: '#4D5D6B',
      g_16: '#DEE6EB',
      g_17: '#2F404F',
    },
    light_blue: '#8c97b2',
    light_mint: '#EDFFFF',
    navys: {
      n_01: '#414E81',
    },
    error: {
      error_01: '#EE5454',
      bg: '#FEDADA',
    },
  },
  state: {
    info: '#10cfc9',
    success: '#1c84c6',
    ready: '#1ab394',
    error: '#ee5454',
  },
  text: {
    primary: '#10cfc9',
    disabled: '#e5e5e6',
    warning: '#f8ac59',

    sidebar: {
      category: '#8d97b2',
      inner_menu: '#8791aa',
      menu_hover: '#dde7ff',
      menu_active: '#40e1e3',
    },

    footer: {
      strong: '#9fa4a9',
      light: '#c5c8ce',
    },
  },
  border: {
    card: '#e7eaec',

    sidebar: {
      full_line: '#3f4963',
    },
  },
  bg: {
    sidebar: {
      menu: '#353e56',
      menu_hover: '#15243B',
    },
  },
  icon: {
    fill: {
      select_arrow: '#70777e',
    },
    stroke: {},
  },
}

export default Colors
